import { render } from "./DropdownRenderer.vue?vue&type=template&id=38242b38&scoped=true"
import script from "./DropdownRenderer.vue?vue&type=script&lang=ts"
export * from "./DropdownRenderer.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-38242b38"

export default script